import { InjectionToken } from "@angular/core";
import { LocalAddressSearchServiceInterface } from "./local-address-search.service.interface";

export const LocalAddressSearchServiceTaken = new InjectionToken<LocalAddressSearchServiceInterface>('LocalAddressSearchServiceInterface');
